import React, { ReactNode } from 'react'
import { FormattedMessage } from 'react-intl'

import s from './styles.module.scss'

import { breakpoints, useMediaQuery } from '../../../../../lib/hooks'

export interface ISummaryContent {
  title: ReactNode
  hrefId: string
  article?: string
  subArticles?: ISummaryContent[]
  annex?: string
  isItalic?: boolean
}

const Summary = ({ summaryContent }: { summaryContent: ISummaryContent[] }) => {
  const isMobile = useMediaQuery(breakpoints.newMobile)
  const SummaryRender = ({
    summaryContent,
    index = { index: 0 },
    depth = 0,
  }: {
    summaryContent: ISummaryContent[]
    index?: { index: number }
    depth?: number
  }) => (
    <>
      {summaryContent.map((content) => {
        index.index += 1
        return (
          <React.Fragment key={index.index}>
            <div className={s.line}>
              {content.article ? (
                <>
                  {depth === 0 ? (
                    <div className={s.flex}>
                      <p className={s.rightSpacer}>
                        {!isMobile && (
                          <>
                            <FormattedMessage
                              id='ui.Summary.article'
                              defaultMessage='Article'
                            />{' '}
                          </>
                        )}
                        {content.article}.
                      </p>
                      <a
                        className={s.hoverUnderline}
                        href={`#${content.hrefId}`}
                      >
                        {content.title}
                      </a>
                    </div>
                  ) : (
                    <div className={s.flex}>
                      <p
                        style={{ marginLeft: (depth * 20).toString() + 'px' }}
                        className={s.rightSpacer}
                      >
                        {content.article}.
                      </p>
                      <a
                        className={s.hoverUnderline}
                        href={`#${content.hrefId}`}
                      >
                        {content.title}
                      </a>
                    </div>
                  )}
                </>
              ) : content.annex ? (
                <div className={s.flex}>
                  <p className={s.rightSpacer}>
                    <FormattedMessage
                      id='ui.Summary.annex'
                      defaultMessage='ANNEXE'
                    />{' '}
                    {content.annex}
                  </p>
                  <a className={s.hoverUnderline} href={`#${content.hrefId}`}>
                    {content.title}
                  </a>
                </div>
              ) : (
                <a className={s.hoverUnderline} href={`#${content.hrefId}`}>
                  {content.title}
                </a>
              )}
            </div>
            {content.subArticles && (
              <SummaryRender
                summaryContent={content.subArticles}
                index={index}
                depth={depth + 1}
              />
            )}
          </React.Fragment>
        )
      })}
    </>
  )

  return (
    <div className={s.summary}>
      <h2>
        <FormattedMessage id='ui.Summary.summary' defaultMessage='Sommaire' />
      </h2>
      <div>
        <SummaryRender summaryContent={summaryContent} />
      </div>
    </div>
  )
}
export default Summary
